var map = {
	"./armenia.svg": "1342",
	"./australia.svg": "7379",
	"./azerbaijan.svg": "b8ba",
	"./belarus.svg": "2efd",
	"./belgium.svg": "c794",
	"./brazil.svg": "ca95",
	"./bulgaria.svg": "545f",
	"./china.svg": "074c",
	"./empty-avatar.svg": "cd7c",
	"./england.svg": "2eee",
	"./estonia.svg": "4c26",
	"./finland.svg": "15b5",
	"./georgia.svg": "969c",
	"./germany.svg": "0e55",
	"./india.svg": "33b0",
	"./iran.svg": "0d8c",
	"./italy.svg": "ee79",
	"./kazakhstan.svg": "881f",
	"./kyrgyzstan.svg": "16f2",
	"./latvia.svg": "140b",
	"./litva.svg": "9eec",
	"./mexico.svg": "e7bc",
	"./moldavia.svg": "53f2",
	"./poland.svg": "cfb8",
	"./russia.svg": "73af",
	"./sweden.svg": "da16",
	"./tajikistan.svg": "08af",
	"./turkey.svg": "4f75",
	"./ukrain.svg": "8428",
	"./usa.svg": "d0ff",
	"./uzbekistan.svg": "d0c9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b292";